export enum OutboundShipmentSource {
  Api = "api",
  Checkout = "checkout",
  FulfillmentGroups = "fulfillment-groups",
  OmsReturnLabel = "oms-return-label",
  RateCalculator = "rate-calculator",
}
